import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from "../../Common/tokenDecoder";

export default {
    saveField,
    editData,
    getAllDivisionsByEstateID,
    getOperationEntityByType,
    getCollectionPointCategoryIDByEstateID,
    getGroupsForDropdown,
    GetAllEstatesByGroupID,
    getCollectionPointByID,
    getFieldFilterData,
    getEstatesByGroupID
};

async function saveField(data) {
    let field = {
        fieldID: 0,
        collectionPointID: parseInt(data.collectionPointID),
        fieldCode: data.fieldCode,
        fieldName: data.fieldName,
        fieldLocation: data.fieldLocation,
        areaofaSection: parseFloat(data.areaofaSection),
        yearofPlanting: data.yearofPlanting + '-01',
        typesofPlantsID: parseInt(data.typesofPlantsID),
        drainageLengths: parseFloat(data.drainageLengths),
        spaceBetweenPlants: parseFloat(data.spaceBetweenPlants),
        numberOfTeaBushes: parseInt(data.numberOfTeaBushes),
        plantingTypeID: parseInt(data.plantingTypeID),
        numberOfShadeTrees: parseInt(data.numberOfShadeTrees),
        clonePercentage: data.typesofPlantsID != 3 ? 0 : parseInt(data.clonePercentage),
        seedlingPercentage: data.typesofPlantsID != 3 ? 0 : parseInt(data.seedlingPercentage),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
        createdDate: new Date().toISOString(),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive
    };
    const response = await CommonPost('/api/Field/SaveField', null, field);
    return response;
}

async function editData(data) {
    let field = {
        fieldID: data.fieldID,
        collectionPointID: parseInt(data.collectionPointID),
        fieldCode: data.fieldCode,
        fieldName: data.fieldName,
        fieldLocation: data.fieldLocation,
        areaofaSection: parseFloat(data.areaofaSection),
        yearofPlanting: data.yearofPlanting + '-01',
        typesofPlantsID: parseInt(data.typesofPlantsID),
        drainageLengths: parseFloat(data.drainageLengths),
        spaceBetweenPlants: parseFloat(data.spaceBetweenPlants),
        numberOfTeaBushes: parseInt(data.numberOfTeaBushes),
        plantingTypeID: parseInt(data.plantingTypeID),
        numberOfShadeTrees: parseInt(data.numberOfShadeTrees),
        clonePercentage: data.typesofPlantsID != 3 ? 0 : parseInt(data.clonePercentage),
        seedlingPercentage: data.typesofPlantsID != 3 ? 0 : parseInt(data.seedlingPercentage),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,


    };
    const response = await CommonPost('/api/Field/UpdateField', null, field);
    return response;
}

async function getAllDivisionsByEstateID(estateID) {
    var divisionArray = [];

    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]

    }
    return divisionArray;
}

async function getOperationEntityByType(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        
    }
    return array;
}

async function getCollectionPointByID(id) {
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointById', 'id=' + id);
    return response.data;
}

async function getCollectionPointCategoryIDByEstateID(estateID) {
    var collectionPointCategoryArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointCategoryIDByEstateID', 'estateID=' + estateID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionPointCategoryArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointCategoryArray;
}

async function getGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllEstatesByGroupID(groupID) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + groupID)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;

}

async function getFieldFilterData(data) {
    var filterModel = {
        groupID: data.groupID,
        operationEntityID: data.estateID,
        collectionPointID: data.collectionPointCategoryID
    }
    const response = await CommonPost('/api/Field/FilterField', null, filterModel);
    return response.data;
}



